import { FC, createContext, useContext, useState, useCallback } from 'react'

import {
  QueryRequestContextProps,
  QueryState,
  WithChildren,
  initialQueryState,
} from '_metronic/helpers'
import { EsusEnvioFiltros } from '../../core/_models'

/**
 * Estado de filtro/paginação da listagem de envios.
 *
 * Diferença deliberada do `QueryRequestProvider` de `apps/importacao`: aqui os filtros vivem em
 * `state.params` tipado (`QueryState<EsusEnvioFiltros>`), e **não** empacotados em `search` no
 * formato RSQL `campo:valor`. O endpoint de E4c recebe parâmetros discretos
 * (`@ParameterObject EsusEnvioFiltroDto`); mandar RSQL faria o backend ignorar o filtro em silêncio.
 */
const initialState: QueryState<EsusEnvioFiltros> = {
  ...initialQueryState,
  sort: 'id',
  order: 'desc',
  params: {},
}

const QueryRequestContext = createContext<QueryRequestContextProps<EsusEnvioFiltros>>({
  state: initialState,
  updateState: () => {},
})

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const [state, setState] = useState<QueryState<EsusEnvioFiltros>>(initialState)

  const updateState = useCallback(
    (updates: Partial<QueryState<EsusEnvioFiltros>>) =>
      setState((prev) => ({ ...prev, ...updates })),
    []
  )

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
